import { Pipe, PipeTransform } from '@angular/core';
import { ReportAccessList, ReportListModel } from '../../../../shared/models/report.model';

@Pipe({
  name: 'searchReport'
})
export class SearchReportPipe implements PipeTransform {

  transform<T>(reports: T[], query: string | undefined): T[] {
    if (!query) {
      return reports;
    }
    return reports.filter(report => {
      if (report instanceof ReportListModel || report instanceof ReportAccessList) {
        return report.name.includes(query) || report.tags.map(tag=>tag.name).includes(query) || report.description.includes(query);
      }
      return false;
    });

  }

}
